import { render, staticRenderFns } from "./backoffice-chat.vue?vue&type=template&id=58bf66ac&scoped=true"
import script from "./backoffice-chat.ts?vue&type=script&lang=ts&external"
export * from "./backoffice-chat.ts?vue&type=script&lang=ts&external"
import style0 from "./backoffice-chat.scss?vue&type=style&index=0&id=58bf66ac&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bf66ac",
  null
  
)

export default component.exports